import React, { useEffect, useState } from "react";
import { GalleryData } from "./PortfolioGalleryData";
import "./PortfolioGallery.css";

import "react-photo-view/dist/react-photo-view.css";

import PortfolioGalleryImages from "./PortfolioGalleryImages";
const PortfolioGallery = () => {
  const [data, setData] = useState([]);
  const [dataToShow, setDataToShow] = useState(9);
  const [collection, setCollection] = useState([]);

  const showData = data.slice(0, dataToShow);
  useEffect(() => {
    setData(GalleryData);
    setCollection([...new Set(GalleryData.map((item) => item.titile))]);
  }, []);

  const gallery_filter = (itemData) => {
    const filterData = GalleryData.filter((item) => item.titile === itemData);
    setData(filterData);
  };
  return (
    <div className="mt-[-70px]">
      <div className="galleryWrapper">
        <div className="navbar">
          <ul>
            <li>
              <p onClick={() => setData(GalleryData)}>All</p>
            </li>
            {collection.map((item) => (
              <li>
                <p
                  onClick={() => {
                    gallery_filter(item);
                  }}
                >
                  {item}
                </p>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <PortfolioGalleryImages
            setDataToShow={setDataToShow}
            showData={showData}
            data={data}
            dataToShow={dataToShow}
            countColum="3"
            gap="10"
          />
        </div>
      </div>
    </div>
  );
};

export default PortfolioGallery;
